import { Component } from '@angular/core';
import { PartnerWiseChartHandler } from './partnerWiseChart.handler.';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { DashboardService } from '../../services/dashboard.service';

@Component({
  selector: 'sym-partner-chart',
  templateUrl: './partnerWiseChart.component.html',
  styleUrls: ['./partnerWiseChart.component.scss'],
})
export class PartnerWiseChartComponent extends PartnerWiseChartHandler {
  constructor(public service: DashboardService, public settingService: SettingService) {
    super(service, settingService);
  }
}
